/* @generated from adl module ferovinum.app.frontegg */

import * as ADL from './../../runtime/adl';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';

export interface FronteggPrehookContext {
  applicationId: (common_strings.StringNE|null);
  tenantId: (common_strings.StringNE|null);
  userId: (common_strings.StringNE|null);
  referer: (common_strings.StringNE|null);
}

export function makeFronteggPrehookContext(
  input: {
    applicationId: (common_strings.StringNE|null),
    tenantId: (common_strings.StringNE|null),
    userId: (common_strings.StringNE|null),
    referer: (common_strings.StringNE|null),
  }
): FronteggPrehookContext {
  return {
    applicationId: input.applicationId,
    tenantId: input.tenantId,
    userId: input.userId,
    referer: input.referer,
  };
}

const FronteggPrehookContext_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"applicationId","default":{"kind":"nothing"},"name":"applicationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"tenantId","default":{"kind":"nothing"},"name":"tenantId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"referer","default":{"kind":"nothing"},"name":"referer","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"FronteggPrehookContext","version":{"kind":"nothing"}}};

export const snFronteggPrehookContext: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggPrehookContext"};

export function texprFronteggPrehookContext(): ADL.ATypeExpr<FronteggPrehookContext> {
  return {value : {typeRef : {kind: "reference", value : snFronteggPrehookContext}, parameters : []}};
}

export interface FronteggJwtMetadata {
  userId: (ferovinum_app_db.AppUserId|null);
  roles: (string[]|null);
}

export function makeFronteggJwtMetadata(
  input: {
    userId: (ferovinum_app_db.AppUserId|null),
    roles: (string[]|null),
  }
): FronteggJwtMetadata {
  return {
    userId: input.userId,
    roles: input.roles,
  };
}

const FronteggJwtMetadata_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AppUserId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}}]}},"name":"FronteggJwtMetadata","version":{"kind":"nothing"}}};

export const snFronteggJwtMetadata: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtMetadata"};

export function texprFronteggJwtMetadata(): ADL.ATypeExpr<FronteggJwtMetadata> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtMetadata}, parameters : []}};
}

export type FronteggJwtType = 'userToken' | 'userApiToken' | 'tenantApiToken';
export const valuesFronteggJwtType : FronteggJwtType[] = ['userToken', 'userApiToken', 'tenantApiToken'];

const FronteggJwtType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userToken","default":{"kind":"nothing"},"name":"userToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"userApiToken","default":{"kind":"nothing"},"name":"userApiToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"tenantApiToken","default":{"kind":"nothing"},"name":"tenantApiToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"FronteggJwtType","version":{"kind":"nothing"}}};

export const snFronteggJwtType: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtType"};

export function texprFronteggJwtType(): ADL.ATypeExpr<FronteggJwtType> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtType}, parameters : []}};
}

export interface FronteggJwtClaims {
  sub: common_strings.StringNE;
  tenantId: common_strings.StringNE;
  roles: common_strings.StringNE[];
  permissions: common_strings.StringNE[];
  metadata: FronteggJwtMetadata;
  jwtType: FronteggJwtType;
  email: (common_strings.StringNE|null);
  userId: (common_strings.StringNE|null);
  applicationId: (common_strings.StringNE|null);
}

export function makeFronteggJwtClaims(
  input: {
    sub: common_strings.StringNE,
    tenantId: common_strings.StringNE,
    roles: common_strings.StringNE[],
    permissions: common_strings.StringNE[],
    metadata: FronteggJwtMetadata,
    jwtType: FronteggJwtType,
    email: (common_strings.StringNE|null),
    userId: (common_strings.StringNE|null),
    applicationId: (common_strings.StringNE|null),
  }
): FronteggJwtClaims {
  return {
    sub: input.sub,
    tenantId: input.tenantId,
    roles: input.roles,
    permissions: input.permissions,
    metadata: input.metadata,
    jwtType: input.jwtType,
    email: input.email,
    userId: input.userId,
    applicationId: input.applicationId,
  };
}

const FronteggJwtClaims_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sub","default":{"kind":"nothing"},"name":"sub","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"tenantId","default":{"kind":"nothing"},"name":"tenantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"permissions","default":{"kind":"nothing"},"name":"permissions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"metadata","default":{"kind":"nothing"},"name":"metadata","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggJwtMetadata"}},"parameters":[]}},{"annotations":[],"serializedName":"type","default":{"kind":"nothing"},"name":"jwtType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggJwtType"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"applicationId","default":{"kind":"nothing"},"name":"applicationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"FronteggJwtClaims","version":{"kind":"nothing"}}};

export const snFronteggJwtClaims: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtClaims"};

export function texprFronteggJwtClaims(): ADL.ATypeExpr<FronteggJwtClaims> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtClaims}, parameters : []}};
}

export interface FronteggJwtSubject {
  vendorMetaData: ({}|null|null);
}

export function makeFronteggJwtSubject(
  input: {
    vendorMetaData: ({}|null|null),
  }
): FronteggJwtSubject {
  return {
    vendorMetaData: input.vendorMetaData,
  };
}

const FronteggJwtSubject_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"vendorMetaData","default":{"kind":"nothing"},"name":"vendorMetaData","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}]}}]}},"name":"FronteggJwtSubject","version":{"kind":"nothing"}}};

export const snFronteggJwtSubject: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtSubject"};

export function texprFronteggJwtSubject(): ADL.ATypeExpr<FronteggJwtSubject> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtSubject}, parameters : []}};
}

export interface FronteggJwtPrehookData {
  claims: FronteggJwtClaims;
  subject: (FronteggJwtSubject|null);
}

export function makeFronteggJwtPrehookData(
  input: {
    claims: FronteggJwtClaims,
    subject: (FronteggJwtSubject|null),
  }
): FronteggJwtPrehookData {
  return {
    claims: input.claims,
    subject: input.subject,
  };
}

const FronteggJwtPrehookData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"claims","default":{"kind":"nothing"},"name":"claims","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggJwtClaims"}},"parameters":[]}},{"annotations":[],"serializedName":"subject","default":{"kind":"nothing"},"name":"subject","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggJwtSubject"}},"parameters":[]}]}}]}},"name":"FronteggJwtPrehookData","version":{"kind":"nothing"}}};

export const snFronteggJwtPrehookData: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtPrehookData"};

export function texprFronteggJwtPrehookData(): ADL.ATypeExpr<FronteggJwtPrehookData> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtPrehookData}, parameters : []}};
}

export interface FronteggPrehookReq<T> {
  eventKey: common_strings.StringNE;
  prehookContext: FronteggPrehookContext;
  data: T;
}

export function makeFronteggPrehookReq<T>(
  input: {
    eventKey: common_strings.StringNE,
    prehookContext: FronteggPrehookContext,
    data: T,
  }
): FronteggPrehookReq<T> {
  return {
    eventKey: input.eventKey,
    prehookContext: input.prehookContext,
    data: input.data,
  };
}

const FronteggPrehookReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"eventKey","default":{"kind":"nothing"},"name":"eventKey","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"prehookContext","default":{"kind":"nothing"},"name":"prehookContext","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggPrehookContext"}},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"FronteggPrehookReq","version":{"kind":"nothing"}}};

export const snFronteggPrehookReq: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggPrehookReq"};

export function texprFronteggPrehookReq<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<FronteggPrehookReq<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.frontegg",name : "FronteggPrehookReq"}}, parameters : [texprT.value]}};
}

export type FronteggPrehookVerdict = 'allow' | 'block';
export const valuesFronteggPrehookVerdict : FronteggPrehookVerdict[] = ['allow', 'block'];

const FronteggPrehookVerdict_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The user can continue with the flow\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"allow","default":{"kind":"nothing"},"name":"allow","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"The user cannot continue with the flow\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"block","default":{"kind":"nothing"},"name":"block","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"FronteggPrehookVerdict","version":{"kind":"nothing"}}};

export const snFronteggPrehookVerdict: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggPrehookVerdict"};

export function texprFronteggPrehookVerdict(): ADL.ATypeExpr<FronteggPrehookVerdict> {
  return {value : {typeRef : {kind: "reference", value : snFronteggPrehookVerdict}, parameters : []}};
}

export interface FronteggPrehookError {
  /**
   * The HTTP Status
   */
  status: number;
  /**
   * The error message to display to the user
   */
  message: common_strings.StringNE[];
}

export function makeFronteggPrehookError(
  input: {
    status: number,
    message: common_strings.StringNE[],
  }
): FronteggPrehookError {
  return {
    status: input.status,
    message: input.message,
  };
}

const FronteggPrehookError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The HTTP Status\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"value":"The error message to display to the user\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"FronteggPrehookError","version":{"kind":"nothing"}}};

export const snFronteggPrehookError: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggPrehookError"};

export function texprFronteggPrehookError(): ADL.ATypeExpr<FronteggPrehookError> {
  return {value : {typeRef : {kind: "reference", value : snFronteggPrehookError}, parameters : []}};
}

export interface FronteggJwtPrehookRespClaims {
  tenantId: common_strings.StringNE;
  customClaims: (FronteggJwtMetadata|null);
}

export function makeFronteggJwtPrehookRespClaims(
  input: {
    tenantId: common_strings.StringNE,
    customClaims: (FronteggJwtMetadata|null),
  }
): FronteggJwtPrehookRespClaims {
  return {
    tenantId: input.tenantId,
    customClaims: input.customClaims,
  };
}

const FronteggJwtPrehookRespClaims_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"tenantId","default":{"kind":"nothing"},"name":"tenantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"customClaims","default":{"kind":"nothing"},"name":"customClaims","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggJwtMetadata"}},"parameters":[]}]}}]}},"name":"FronteggJwtPrehookRespClaims","version":{"kind":"nothing"}}};

export const snFronteggJwtPrehookRespClaims: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtPrehookRespClaims"};

export function texprFronteggJwtPrehookRespClaims(): ADL.ATypeExpr<FronteggJwtPrehookRespClaims> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtPrehookRespClaims}, parameters : []}};
}

export interface FronteggJwtPrehookResp {
  claims: FronteggJwtPrehookRespClaims;
  expiresIn: (number|null);
}

export function makeFronteggJwtPrehookResp(
  input: {
    claims: FronteggJwtPrehookRespClaims,
    expiresIn: (number|null),
  }
): FronteggJwtPrehookResp {
  return {
    claims: input.claims,
    expiresIn: input.expiresIn,
  };
}

const FronteggJwtPrehookResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"claims","default":{"kind":"nothing"},"name":"claims","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggJwtPrehookRespClaims"}},"parameters":[]}},{"annotations":[],"serializedName":"expiresIn","default":{"kind":"nothing"},"name":"expiresIn","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}}]}},"name":"FronteggJwtPrehookResp","version":{"kind":"nothing"}}};

export const snFronteggJwtPrehookResp: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggJwtPrehookResp"};

export function texprFronteggJwtPrehookResp(): ADL.ATypeExpr<FronteggJwtPrehookResp> {
  return {value : {typeRef : {kind: "reference", value : snFronteggJwtPrehookResp}, parameters : []}};
}

export interface FronteggPrehookResp<T> {
  continue: boolean;
  verdict: FronteggPrehookVerdict;
  error: (FronteggPrehookError|null);
  response: T;
}

export function makeFronteggPrehookResp<T>(
  input: {
    continue: boolean,
    verdict: FronteggPrehookVerdict,
    error: (FronteggPrehookError|null),
    response: T,
  }
): FronteggPrehookResp<T> {
  return {
    continue: input.continue,
    verdict: input.verdict,
    error: input.error,
    response: input.response,
  };
}

const FronteggPrehookResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.frontegg","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"continue","default":{"kind":"nothing"},"name":"continue","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"verdict","default":{"kind":"nothing"},"name":"verdict","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggPrehookVerdict"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.frontegg","name":"FronteggPrehookError"}},"parameters":[]}]}},{"annotations":[],"serializedName":"response","default":{"kind":"nothing"},"name":"response","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"FronteggPrehookResp","version":{"kind":"nothing"}}};

export const snFronteggPrehookResp: ADL.ScopedName = {moduleName:"ferovinum.app.frontegg", name:"FronteggPrehookResp"};

export function texprFronteggPrehookResp<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<FronteggPrehookResp<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.frontegg",name : "FronteggPrehookResp"}}, parameters : [texprT.value]}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.frontegg.FronteggPrehookContext" : FronteggPrehookContext_AST,
  "ferovinum.app.frontegg.FronteggJwtMetadata" : FronteggJwtMetadata_AST,
  "ferovinum.app.frontegg.FronteggJwtType" : FronteggJwtType_AST,
  "ferovinum.app.frontegg.FronteggJwtClaims" : FronteggJwtClaims_AST,
  "ferovinum.app.frontegg.FronteggJwtSubject" : FronteggJwtSubject_AST,
  "ferovinum.app.frontegg.FronteggJwtPrehookData" : FronteggJwtPrehookData_AST,
  "ferovinum.app.frontegg.FronteggPrehookReq" : FronteggPrehookReq_AST,
  "ferovinum.app.frontegg.FronteggPrehookVerdict" : FronteggPrehookVerdict_AST,
  "ferovinum.app.frontegg.FronteggPrehookError" : FronteggPrehookError_AST,
  "ferovinum.app.frontegg.FronteggJwtPrehookRespClaims" : FronteggJwtPrehookRespClaims_AST,
  "ferovinum.app.frontegg.FronteggJwtPrehookResp" : FronteggJwtPrehookResp_AST,
  "ferovinum.app.frontegg.FronteggPrehookResp" : FronteggPrehookResp_AST
};
